export default __webpack_public_path__ + "locales/it/DeleteDialog.json?hash=205e2c5ba08770e1d511ab63d86d3c6d";